import { Box } from "@mui/material";
import Header from "../../components/Header";

const MISReports = () => (
  <Box m="20px">
    <Header title="MIS REPORTS" subtitle="Aggregated reports across all school clients" />
  </Box>
);

export default MISReports;
